import axios from 'axios'

import { domain } from './main'

import {
    ProfileIdentifierActionTypes,
    GetProfileIdentifierTypes,
    ProfileRemoveDataActionTypes,
    GetProfileRemoveDataTypes
} from '../store/reducers/ProfileRemoveDataSlice'
import {
    ProfileTrashDataActionTypes,
    GetProfileTrashDataTypes
} from '../store/reducers/ProfileTrashDataSlice'

const instance = axios.create({
    withCredentials: true,
    baseURL: domain
})

export const ProfileDatasAPI = {
    // IDENTIFIER
    async identifier({
            phone
        }: GetProfileIdentifierTypes
    ) {
        return await instance.post<ProfileIdentifierActionTypes>(`/profile/data/identifier`, {phone})
            .then(res => {
                return res
            })
    },
    // REMOVE DATA
    async removeData({
            code,
            sessions,
            addresses,
            likes,
            rates
        }: GetProfileRemoveDataTypes
    ) {
        return await instance.post<ProfileRemoveDataActionTypes>(`/profile/data/remove`, {code, sessions, addresses, likes, rates})
            .then(res => {
                return res
            })
    },
    // TRASH
    async trash({
            code
        }: GetProfileTrashDataTypes
    ) {
        return await instance.post<ProfileTrashDataActionTypes>(`/profile/data/trash`, {code})
            .then(res => {
                return res
            })
    }
}